import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrowserUpdatedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"browser_updated"}/>
}
